<script>
import { mapState } from 'vuex';

// @vuese
// Komponent do sprawdzania uprawnień
// @group Helpers
export default {
  name: 'CheckPermission',
  props: {
    // Wymagane uprawnienia
    permissions: {
      type: [String, Array],
      required: false
    },
    // Jak łączyć (OR/AND)
    joinType: {
      type: String,
      required: false,
      default: 'AND'
    },
    // Identyfikator encji
    entityId: {
      type: [String, Number, Array],
      required: false
    },
    // Typ encji
    entityType: {
      type: String,
      required: false
    }
  },
  computed: {
    hasEntityId() {
      return this.entityId && (!Array.isArray(this.entityId) || this.entityId.length);
    },
    toCheck() {
      const toCheck = (Array.isArray(this.permissions) ? this.permissions : [this.permissions]).filter(Boolean);
      if (!this.hasEntityId || !this.entityType) {
        return toCheck;
      }
      if (Array.isArray(this.entityId)) {
        return toCheck
          .map(permission => this.entityId.map(entityId => `${permission}:${this.entityType}:${entityId}`))
          .reduce((allPermissions, currentPermissions) => allPermissions.concat(currentPermissions), []);
      }
      return toCheck.map(permission => `${permission}:${this.entityType}:${this.entityId}`);
    },
    ...mapState({
      hasPermission(state) {
        if (!this.permissions || !this.permissions.length) {
          return true;
        }
        const checkedPermissions = state.auth.checkPermission.permissions;
        if (!this.toCheck || !this.toCheck.length) {
          return true;
        }
        switch (this.joinType) {
          case 'OR':
            return this.toCheck.some(permission => !!checkedPermissions[permission]);
          case 'AND':
            return this.toCheck.every(permission => !!checkedPermissions[permission]);
          default:
            return false;
        }
      }
    })
  },
  watch: {
    toCheck: {
      handler(permissions) {
        this.checkPermissions(permissions);
      },
      immediate: true
    }
  },
  methods: {
    // @vuese
    // Wysyłanie zapytania o uprawnienia
    checkPermissions(toCheck) {
      this.$store.dispatch('auth/checkPermissions', toCheck);
    }
  },
  render() {
    if (!this.permissions || !this.permissions.length || this.hasPermission) {
      return this.$scopedSlots.default({});
    }
  }
};
</script>
